import {Component, OnInit, Input} from '@angular/core';
import {isSmallerThanIpad} from '../../../../../helpers';
import {animate, state, style, transition, trigger, group} from "@angular/animations";

@Component({
  selector: 'app-sticky-footer-button',
  templateUrl: './sticky-footer-button.component.html',
  styleUrls: ['./sticky-footer-button.component.css'],
  animations: [
    trigger('slideInOut', [
        state('in', style({height: '*', opacity: 0})),
        transition(':leave', [
            style({height: '*', opacity: 1}),
            group([
                animate(300, style({height: 0})),
                animate('200ms ease-in-out', style({opacity: '0'}))
            ])

        ]),
        transition(':enter', [
            style({height: '0', opacity: 0}),
            group([
                animate(300, style({height: '*'})),
                animate('400ms ease-in-out', style({opacity: '1'}))
            ])
        ])
    ])
]
})
export class StickyFooterButtonComponent implements OnInit {

  isSmallerThanIpad = isSmallerThanIpad;

  @Input()
  url: string;

  @Input()
  delayInMs: number;

  @Input()
  descText: string;

  @Input()
  buttonText: string;

  @Input()
  buttonColor: string;

  isShow = false;

  constructor() {
    this.delayInMs = 60000;
    this.buttonColor = "secondary";
  }

  ngOnInit() {
    setTimeout(() => {
        this.isShow = true;
    }, this.delayInMs);
  }

  toggleDisplay() {
    this.isShow = !this.isShow;
  }

  getClientWidth() {
    return document.body.clientWidth.toString() + 'px';
  }
}
